module.exports = __webpack_public_path__ + "components/easter-infographic/static/resort-opening-infographic--france--full-3eddf1fe04f8d069196a5918176ec804.jpg";